"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
OutletController.$inject = ['$scope', 'api', 'categories', 'products', 'category', '_shop'];
function OutletController($scope, api, categories, products, category, _shop) {
    $scope.categories = categories.items;
    $scope.category = category;
    $scope.title = category.name ? category.name : 'Outlet ponuda';
    $scope.mobile_title = category.name ? 'Outlet: ' + category.name : 'Outlet: Sve kategorije';
    $scope.cart_visible = false;
    $scope.products = [];
    if (category._id) {
        lodash_1.default.each(products.items, function (child, index) {
            if (child.category_id == category._id) {
                $scope.products.push(child);
            }
        });
    }
    else {
        $scope.products = products.items;
    }
    $scope.showFilters = false;
    $scope.$watch('showFilters', function (val) {
        $scope.showFilters = val;
    });
    $scope.sortArray = _shop.getSortTypes();
    $scope.sortItems = {};
    $scope.sortProducts = function (item) {
        $scope.sortItems = item;
        lodash_1.default.each($scope.sortArray, function (child, index) {
            child.active = 0;
        });
        item.active = 1;
    };
    $scope.close_categories = false;
    $scope.$on('remove_from_cart', function (event, data) {
        var item = lodash_1.default.find($scope.products, { _id: data._id });
        if (item) {
            item.quantity = 0;
        }
    });
    $scope.$on('change_quantity_from_cart', function (event, data) {
        var item = lodash_1.default.find($scope.products, { _id: data._id });
        if (item) {
            item.quantity = data.quantity;
        }
    });
}
exports.OutletController = OutletController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/outlet/controllers/OutletController.js
// module id = 379
// module chunks = 0